<template>
  <v-container fluid class="pa-4">

    <!-- ================= Toolbar ================= -->
    <v-card elevation="2" class="rounded-lg mb-4">
      <v-toolbar flat color="primary" dark>

        <v-icon left>
          mdi-file-document-outline
        </v-icon>

        <v-toolbar-title>
          Estado de Cuenta de Clientes
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn color="white" outlined @click="imprimirPDF">
          <v-icon left>
            mdi-printer
          </v-icon>

          Imprimir PDF
        </v-btn>

        <v-btn
    color="blue"
    outlined
    @click="enviarEstadoCuenta"
>
    <v-icon left>
        mdi-email
    </v-icon>

    Enviar Estado de Cuenta
</v-btn>

      </v-toolbar>
    </v-card>

    <!-- ================= Filtros ================= -->

    <v-card elevation="2" class="rounded-lg mb-4 pa-4">

      <v-row>

        <v-col cols="12" md="4">

          <v-autocomplete v-model="filtros.cliente" :items="dataCliente" item-text="strNombre" item-value="intCliente"
            label="Cliente" outlined dense clearable hide-no-data hide-selected />

        </v-col>

       

        <v-col cols="12" md="3">

          <v-text-field v-model="filtros.mes" type="month" label="Mes" outlined dense />

        </v-col>

        <v-col cols="12" md="2" class="d-flex align-center">

          <v-btn color="primary" block large @click="buscar">
            <v-icon left>
              mdi-magnify
            </v-icon>

            Buscar
          </v-btn>

        </v-col>

        <v-col cols="12" md="2" class="d-flex align-center">

<v-btn color="primary" block large @click="cerrarMes">
  <v-icon left>
    mdi-check-circle
  </v-icon>

  Cerrar mes
</v-btn>

</v-col>

      </v-row>

    </v-card>

    <!-- ================= Datos Cliente ================= -->

    <v-card elevation="2" class="rounded-lg mb-4 pa-4">

      <v-row>

        <v-col cols="12" md="4">
          <strong>Cliente</strong><br>
          {{ cliente.nombre }}
        </v-col>

        <!-- <v-col
            cols="12"
            md="2"
          >
            <strong>RFC</strong><br>
            {{ cliente.rfc }}
          </v-col> -->

        <v-col cols="12" md="2">
          <strong>Teléfono</strong><br>
          {{ cliente.telefono }}
        </v-col>

        <v-col
            cols="12"
            md="2"
          >
            <strong>Email</strong><br>
            {{ cliente.strEmail }}
          </v-col>

        <v-col cols="12" md="2">
          <strong>Saldo a Favor</strong><br>
          ${{ formatMoney(cliente.saldoFavor) }}
        </v-col>

        

      </v-row>

      <v-row>
        <v-col cols="12" md="2">
          <v-btn color="green" block large @click="abonar">
            <v-icon left>
              mdi-plus
            </v-icon>

            Abonar
          </v-btn>
      </v-col>
      <v-col cols="12" md="2">
          <v-btn color="red" block large @click="decrementar">
            <v-icon left>
              mdi-minus
            </v-icon>

            Decrementar
          </v-btn>
      </v-col>
      </v-row>

    </v-card>

    <!-- ================= Tarjetas ================= -->

    <v-row>

      <v-col cols="12" md="3">

        <v-card color="blue lighten-5" class="pa-4" outlined>

          <div class="subtitle-2 grey--text">
            Total Comprado
          </div>

          <div class="display-1 font-weight-bold">
            ${{ formatMoney(resumen.totalComprado) }}
          </div>

        </v-card>

      </v-col>

      <v-col cols="12" md="3">

        <v-card color="green lighten-5" class="pa-4" outlined>

          <div class="subtitle-2 grey--text">
            Total Pagado
          </div>

          <div class="display-1 font-weight-bold green--text">
            ${{ formatMoney(resumen.totalPagado) }}
          </div>

        </v-card>

      </v-col>

      <v-col cols="12" md="3">

        <v-card color="orange lighten-5" class="pa-4" outlined>

          <div class="subtitle-2 grey--text">
            Saldo Pendiente
          </div>

          <div class="display-1 font-weight-bold orange--text">
            ${{ formatMoney(resumen.saldoPendiente) }}
          </div>

        </v-card>

      </v-col>



    </v-row>

    <!-- ================= Tabla ================= -->

    <v-card elevation="2" class="rounded-lg mt-4">

      <v-card-title>

        Movimientos

        <v-spacer></v-spacer>

        <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            dense
            hide-details
            solo
            flat
            style="max-width:300px"
          /> -->

      </v-card-title>

      <v-data-table :headers="headers" :items="movimientos" :search="search" dense class="elevation-0" :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100]
      }">

        <template v-slot:item.dblTotal="{ item }">
          <strong>
            ${{ formatMoney(item.dblTotal) }}
          </strong>
        </template>

        <template v-slot:item.abonado="{ item }">
          <span class="green--text">
            ${{ formatMoney(item.abonado) }}
          </span>
        </template>

        <template v-slot:item.saldo="{ item }">
          <span class="red--text font-weight-bold">
            ${{ formatMoney(item.saldo) }}
          </span>
        </template>

        <template v-slot:item.estado="{ item }">

          <v-chip small dark :color="estadoColor(item.estado)">

            {{ item.estado }}

          </v-chip>

        </template>

        <!-- <template v-slot:item.acciones="{ item }">
  
            <v-tooltip top>
  
              <template v-slot:activator="{ on }">
  
                <v-btn
                  icon
                  v-on="on"
                  @click="verDetalle(item)"
                >
  
                  <v-icon color="primary">
                    mdi-eye
                  </v-icon>
  
                </v-btn>
  
              </template>
  
              <span>Ver detalle</span>
  
            </v-tooltip>
  
          </template> -->

      </v-data-table>

    </v-card>
    <v-dialog
    v-model="dialogAbono"
    max-width="450"
    persistent
>
    <v-card>

      <v-card-title>
    {{ tipoMovimiento === 'abono' ? 'Registrar Abono' : 'Registrar Decremento' }}
</v-card-title>

        <v-card-text>

            <v-text-field
                v-model.number="montoAbono"
                label="Cantidad"
                prefix="$"
                type="number"
                outlined
            />

        </v-card-text>

        <v-card-actions>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="dialogAbono=false"
            >
                Cancelar
            </v-btn>

            <v-btn
                color="primary"
                @click="confirmarAbono"
            >
                Continuar
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
<v-dialog
    v-model="dialogConfirmar"
    max-width="400"
>
    <v-card>

        <v-card-title>
            Confirmar
        </v-card-title>

        <v-card-text>

¿Desea registrar
<strong>{{ tipoMovimiento === 'abono' ? 'un abono' : 'un decremento' }}</strong>
de
<strong>${{ formatMoney(montoAbono) }}</strong>?

</v-card-text>

        <v-card-actions>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="dialogConfirmar=false"
            >
                No
            </v-btn>

            <v-btn
                color="success"
                @click="guardarAbono"
            >
                Sí
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
<v-dialog
    v-model="dialogCerrarMes"
    max-width="450"
>
    <v-card>

        <v-card-title>
            Confirmar cierre de mes
        </v-card-title>

        <v-card-text>

            ¿Está seguro de cerrar el mes
            <strong>{{ filtros.mes }}</strong>?

            <br><br>

            Después de cerrar el mes ya no será posible registrar movimientos para este periodo.

        </v-card-text>

        <v-card-actions>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="dialogCerrarMes = false"
            >
                Cancelar
            </v-btn>

            <v-btn
                color="primary"
                @click="confirmarCerrarMes"
            >
                Cerrar mes
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
<br>
<br>
<br>
<div id="estadoCuentaPDF" class="pdf-container">

<!-- ================= ENCABEZADO ================= -->

<div class="header">

    

    <div class="titulo">
        <h1>ESTADO DE CUENTA</h1>
        <h3>Crédito Clientes</h3>
    </div>

</div>

<hr>

<!-- ================= DATOS ================= -->

<table class="info">

    <tr>

        <td><strong>Cliente</strong></td>
        <td>{{ cliente.nombre }}</td>

        <td><strong>Mes</strong></td>
        <td>{{ filtros.mes }}</td>

    </tr>

    <tr>

        <td><strong>Teléfono</strong></td>
        <td>{{ cliente.telefono }}</td>

        <td><strong>Fecha impresión</strong></td>
        <td>{{ new Date().toLocaleDateString() }}</td>

    </tr>

</table>

<br>

<!-- ================= RESUMEN ================= -->

<table class="resumen">

    <thead>

        <tr>

            <th>Total Comprado</th>
            <th>Total Pagado</th>
            <th>Saldo Pendiente</th>
            <th>Saldo a Favor</th>

        </tr>

    </thead>

    <tbody>

        <tr>



            <td>${{ formatMoney(resumen.totalComprado) }}</td>

            <td>${{ formatMoney(resumen.totalPagado) }}</td>

            <td>${{ formatMoney(resumen.saldoPendiente) }}</td>

            <td>${{ formatMoney(cliente.saldoFavor) }}</td>

        </tr>

    </tbody>

</table>

<br>

<!-- ================= MOVIMIENTOS ================= -->

<h2>Compras</h2>

<table class="tabla">

    <thead>

        <tr>

            <th>Fecha</th>

            <th>Folio</th>

            <th>Descripción</th>

            <th>Cantidad</th>

            <th>Total</th>

        </tr>

    </thead>

    <tbody>

      <tr v-for="item in movimientos" :key="item.intPOSDet">

<td>{{ item.datFechaAlta }}</td>

<td>{{ item.intPOSEnc }}</td>

<td>{{ item.strNombre }}</td>

<td>{{ item.dblCantidad }}</td>

<td>${{ formatMoney(item.dblTotal) }}</td>

</tr>

    </tbody>

</table>

<br>





<br>




</div>
  </v-container>
  
</template>

<script>

import { POSUserFunctions } from "../../controllers/UserController.js";
import { POSDetFunctions,POSEncFunctions } from "../../controllers/POSController.js";
import axios from 'axios';

import {
  Toast,
  ErrorWeb,
} from "../../controllers/DataController.js";
export default {

  name: "EstadoCuentaClientes",

  data() {

    return {
      dialogCerrarMes: false,
      search: "",
      userFunctions: new POSUserFunctions(),
      POSDetFunctions: new POSDetFunctions(),
      POSEncFunctions: new POSEncFunctions(),
      tipoMovimiento: "abono", // abono | decremento
      dataCliente: [],
      dialogAbono: false,
dialogConfirmar: false,

montoAbono: null,
abonos: [],

abono: {
    intCliente: null,
    dblMonto: 0,
    datFecha: null
},
      filtros: {

        cliente: null,
        estado: "Todos",
        mes: new Date().toISOString().substr(0, 7)

      },

      estados: [

        "Todos",
        "Pendiente",
        "Parcial",
        "Pagado"

      ],

      clientes: [],

      cliente: {
    nombre: "",
    telefono: "",
    credito: null,
    saldoFavor: 0
},

      resumen: {

        totalComprado: 0,
        totalPagado: 0,
        saldoPendiente: 0

      },

      headers: [

        {
          text: "Folio",
          value: "intPOSEnc"
        },
        {
          text: "Fecha",
          value: "datFechaAlta"
        },
        //   {
        //     text: "Vencimiento",
        //     value: "vence"
        //   },
        {
          text: "Descripcion",
          value: "strNombre"
        },
        {
          text: "Cantidad",
          value: "dblCantidad"
        },
        {
          text: "Total",
          value: "dblTotal",
          align: "end"
        },
        {
          text: "",
          value: "acciones",
          sortable: false
        }

      ],

      movimientos: [

        //   {
        //     folio: "FAC-0001",
        //     fecha: "10/07/2026",
        //     //vence: "09/08/2026",
        //     total: 3500,
        //     abonado: 3500,
        //     saldo: 0,
        //     estado: "Pagado"
        //   },
        //   {
        //     folio: "FAC-0002",
        //     fecha: "15/07/2026",
        //     //vence: "14/08/2026",
        //     total: 5200,
        //     abonado: 3000,
        //     saldo: 2200,
        //     estado: "Parcial"
        //   },
        //   {
        //     folio: "FAC-0003",
        //     fecha: "18/07/2026",
        //     //vence: "17/08/2026",
        //     total: 2800,
        //     abonado: 0,
        //     saldo: 2800,
        //     estado: "Pendiente"
        //   }

      ]

    }

  },
  mounted() {
    this.cargaCliente();
  },

  methods: {
    async cerrarMes() {
    try {

        if (this.filtros.cliente == null) {
            this.$toast.warning("Favor de elegir cliente", new Toast());
            return;
        }


        this.dialogCerrarMes = true;

    } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
    }
},
async confirmarCerrarMes() {
    try {
        
        this.dialogCerrarMes = false;
        if (this.resumen.saldoPendiente > 0)
        {
          this.$toast.warning("No se puede cerrar el mes debido al saldo pendiente", new Toast());
            return;
        }

        const [anio, mes] = this.filtros.mes.split("-");

        const resultado = await this.POSEncFunctions.cerrarMes(
            this.filtros.cliente,
            anio,
            mes
        );

        if (resultado == 1) {
            this.$toast.warning("El mes ya se encuentra cerrado", new Toast());
            return;
        }

        this.$toast.success("Mes cerrado correctamente", new Toast());

        this.buscar();

    } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
    }
},
async enviarEstadoCuenta(){

try {

    if(!this.filtros.cliente){

        this.$toast.warning(
            "Seleccione cliente",
            new Toast()
        );

        return;
    }


    const cliente = this.dataCliente.find(
        x => x.intCliente == this.filtros.cliente
    );


    if(!cliente.strEmail){

        this.$toast.warning(
            "Cliente sin correo",
            new Toast()
        );

        return;
    }


    const [anio,mes] = this.filtros.mes.split("-");


    let request = {

        intCliente:this.filtros.cliente,

        anio:anio,

        mes:mes,

        correo:""

    };
    console.log(this.POSEncFunctions);

    const respuesta =  await this.POSEncFunctions.enviarEstadoCuenta(request);

    console.log(respuesta);

    this.$toast.success(
        "Correo enviado",
        new Toast()
    );


}
catch(e){

    this.$toast.error(
        ErrorWeb(e),
        new Toast()
    );

}

},
    async buscar() {
    try {
      if(this.filtros.cliente == null)
    {
      this.$toast.warning("Favor de elegir cliente", new Toast());
      return;
    }

        const [anio, mes] = this.filtros.mes.split("-");

        this.movimientos = await this.POSDetFunctions.getDetXCliente(
            this.filtros.cliente,
            anio,
            mes
        );
        const clienteSeleccionado = this.dataCliente.find(
            x => x.intCliente === this.filtros.cliente
        );

        let saldoFinal = await this.POSEncFunctions.getSaldoFinal(
          this.filtros.cliente,
            anio,
            mes
        );
        if (clienteSeleccionado) {
            this.cliente = {
                nombre: clienteSeleccionado.strNombre,
                telefono: clienteSeleccionado.strTelefono,
                credito: clienteSeleccionado.intConditoCredito,
                saldoFavor: Math.max(
            0,
            (saldoFinal.saldoInicial + saldoFinal.pagos) - saldoFinal.compras
        )
            };
        }

        
        
        console.log(saldoFinal);
        
        this.resumen.totalComprado = saldoFinal.compras;
        this.resumen.saldoPendiente = Math.max(0,saldoFinal.compras - (saldoFinal.saldoInicial + saldoFinal.pagos)); 
        this.resumen.totalPagado = saldoFinal.pagos;
        console.log(this.cliente);

    }
    catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
    }
},
async abonar() {
    try {
        if (this.filtros.cliente == null) {
            this.$toast.warning("Favor de elegir cliente", new Toast());
            return;
        }

        this.tipoMovimiento = "abono";
        this.montoAbono = null;
        this.dialogAbono = true;
    }
    catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
    }
},
async decrementar() {
    try {
        if (this.filtros.cliente == null) {
            this.$toast.warning("Favor de elegir cliente", new Toast());
            return;
        }

        this.tipoMovimiento = "decremento";
        this.montoAbono = null;
        this.dialogAbono = true;
    }
    catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
    }
},
confirmarAbono() {

if (!this.montoAbono || this.montoAbono <= 0) {
    this.$toast.warning("Ingrese un monto válido", new Toast());
    return;
}

this.dialogAbono = false;
this.dialogConfirmar = true;

},
async guardarAbono() {
    try {

        this.abono = {
            intCliente: this.filtros.cliente,
            dblMonto: this.montoAbono,
            datFecha: new Date()
        };

        this.dialogConfirmar = false;

        if (this.tipoMovimiento == "abono") {
            await this.POSEncFunctions.savePOSAbono(this.abono);
            this.$toast.success("Abono registrado", new Toast());
        } else {
            await this.POSEncFunctions.savePOSDecremento(this.abono);
            this.$toast.success("Decremento registrado", new Toast());
        }

        this.buscar();
    }
    catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
    }
},
    async cargaCliente() {

      const response = await axios.get("POS_DataCliente/1/1");

      this.dataCliente = response.data;

    },

    

    async imprimirPDF() {



await this.$nextTick();

// esperar imágenes
const imagenes = document.querySelectorAll("#estadoCuentaPDF img");

await Promise.all(
    [...imagenes].map(img => {

        img.crossOrigin = "anonymous";

        if (img.complete && img.naturalWidth !== 0) {
            return Promise.resolve();
        }

        return new Promise(resolve => {
            img.onload = resolve;
            img.onerror = resolve;
        });

    })
);

const element = document.getElementById("estadoCuentaPDF");

const opt = {
    margin: 0.2,
    image: { type: "jpeg", quality: 1 },
    html2canvas: {
        scale: 2,
        useCORS: false
    },
    jsPDF: {
        unit: "in",
        format: "letter",
        orientation: "portrait"
    }
};

await window.html2pdf()
    .set(opt)
    .from(element)
    .save(`EstadoCuenta_${this.cliente.nombre}.pdf`);
},

    //   verDetalle(item) {

    //     console.log(item)

    //   },

    estadoColor(estado) {

      switch (estado) {

        case "Pagado":
          return "green"

        case "Parcial":
          return "orange"

        case "Pendiente":
          return "red"

        default:
          return "grey"

      }

    },

    formatMoney(valor) {

      return Number(valor || 0).toLocaleString("es-MX", {

        minimumFractionDigits: 2,
        maximumFractionDigits: 2

      })

    }

  },

}

</script>

<style scoped>
.v-card {
  border-radius: 12px;
}

.display-1 {
  font-size: 28px;
}

.v-data-table {
  font-size: 14px;
}

.pdf-container{

background:white;

color:#000;

width:210mm;

padding:25px;

font-family:Arial;

font-size:13px;

}

.header{

display:flex;

justify-content:space-between;

align-items:center;

}

.titulo{

text-align:right;

}

.info{

width:100%;

border-collapse:collapse;

}

.info td{

padding:5px;

}

.resumen{

width:100%;

border-collapse:collapse;

}

.resumen th{

background:#1565C0;

color:white;

padding:8px;

}

.resumen td{

border:1px solid #DDD;

text-align:center;

padding:8px;

}

.tabla{

width:100%;

border-collapse:collapse;

}

.tabla th{

background:#1976D2;

color:white;

padding:8px;

}

.tabla td{

border:1px solid #CCC;

padding:6px;

}

.tabla tr:nth-child(even){

background:#F7F7F7;

}

h2{

color:#1976D2;

}

.observaciones{

border:1px solid #DDD;

padding:15px;

}
</style>